<template>
    <div>
        <div class="nav">
            <p>我的收益</p> 
        </div>
        <van-icon name="arrow-left"  class="icon" @click="icon"/>
        <div class="top">
            <p>我的余额</p>
            <p>¥ <span>{{money.gains}}</span></p>
            <p @click="theorder">我要提现</p>
        </div>
        <div class="consume">
            <van-tabs v-model="active" @click="onClick" title-active-color="#000" sticky offset-top="10px">
                <van-tab title="收益明细">
                    <ul>
                        <li v-for="item in earning" :key="item.order_num" @click="withdrawal(item.order_num)">
                            <div class="fl">
                                <p>{{item.name}}</p>
                                <p>{{item.create_time}}</p>
                            </div>
                            <div class="fr">
                                +{{item.gains}}
                            </div>
                        </li>
                    </ul>
                </van-tab>
                <van-tab title="提现记录">
                    <ul>
                        <li></li>
                    </ul>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
import URL from '../api/index'
import Vue from 'vue';
import { Tab, Tabs } from 'vant';
import { Icon } from 'vant';

Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
export default {
    data(){
        return{
            active:0,
            earning:[],
            money:[]
        }
    },
    mounted(){
        let token=this.$route.query.token
        console.log(token);
        
        this.$axios({
            method:'post',
            url:URL.earnings,
            data:{
                token:token,
                page:''
            }
        }).then((res)=>{
            this.earning = res.data.result.list
            this.money = res.data.result
            console.log(res);
        })
    },
    methods:{
        onClick(){},
        icon(){
            this.$router.go(-1)
        },
        withdrawal(e){
            this.$router.push({
                path:'/withdrawal',
                query:{
                    num: e
                }
            })
        },
        theorder(){
            this.$router.push('/theorder')
        }
    }
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}

.icon{
    vertical-align: middle;
    position: fixed;
    line-height: 46px;
    left: 15px;
    top: 0;
    color: #fff;
    z-index: 2
}
.nav{
    width: 100%;
    background-image: linear-gradient(to right, #406df8 , #6289fe);
    line-height: 46px;
    text-align: center;
    color: #fff;
    vertical-align: middle;
}

.top{
    text-align: center;
    width: 100%;
    padding-bottom: 15px;
    background-image: linear-gradient(to right, #406df8 , #6289fe);
}
.top p:first-child{
    font-size: 12px;
    padding-top: 17px;
    color: #c6d1fd;;
}
.top p:nth-child(2){
    color: #ffffff;
    font-size: 24px;
    line-height: 56px;
}
.top p:nth-child(2) span{
    font-size: 28px;
}
.top p:last-child{
    width: 96px;
    background-color: #7298fd;;
    line-height: 33px;
    border-radius: 15px;
    margin: 0 auto;
    color: #ffffff;
    display: none;
}

.van-tabs /deep/ .van-tabs__nav{
    background-color: #f7f7f7;
}
.van-tabs /deep/ .van-sticky{
    font-size: 16px;
    color: #828282;
}
.van-tabs /deep/ .van-tabs__line{
	background-color: #3c69f5;
    width: 30px !important;
    transform: translateX(94px) translateX(-50%);
}
li{
    overflow: hidden;
    margin: 15px 20px;
    border-bottom: 1px solid #dcdcdc;
}
.fl{
    float: left;
    font-size: 15px;
}
.fl p:last-child{
    color: #b7b7b7;
    font-size: 12px;
    line-height: 30px;
}
.fr{
    float: right;
    color: #ed3638;
    font-size: 15px;
}
.active{
    font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/earnings.vue